import clsx from 'clsx';
import React, { useState, useEffect, useRef, FC, ChangeEventHandler } from 'react';

interface pageProps {
    formHandleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    inputName: string
    errorMessage: any
    onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const InputMask: FC<pageProps> = ({ formHandleChange, inputName, errorMessage, onFocus }) => {
    const [card, setCard] = useState<string>("");
    const inputCard = useRef<HTMLInputElement | null>(null);

    const handleChange = () => {
        if (!inputCard.current) return;
        const cardValue = inputCard.current!.value
            .replace(/\D/g, '')
            .match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
        if (!cardValue) return;
        inputCard.current.value = !cardValue[2]
            ? cardValue[1]
            : `${cardValue[1]} ${cardValue[2]}${`${cardValue[3] ? ` ${cardValue[3]}` : ''
            }`}${`${cardValue[4] ? ` ${cardValue[4]}` : ''}`}`;
        const numbers = inputCard.current.value.replace(/(\D)/g, '');
        setCard(numbers);
    };

    useEffect(() => {
        handleChange();
    }, [card]);

    return (
        <>
            <input type="text" className={clsx("form-control form-control-sm", { "is-invalid": errorMessage })} id={inputName} name={inputName} autoComplete="off" ref={inputCard} onChange={e => { handleChange(); formHandleChange(e) }} onFocus={onFocus} placeholder='**** **** **** ****' />
            {errorMessage && (
                <div className="fv-plugins-message-container invalid-feedback">
                    <span role="alert">
                        {errorMessage}
                    </span>
                </div>
            )}
        </>
    );
};

export default InputMask;